import styled from 'styled-components';
import {BLACK, GREY_2} from "../../../utils/colors";

export const Wrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 15px;
  padding: 20px;
  background: #fff;
`;

export const NavIconWrapper = styled.div`
  position: absolute;
  left: 20px;
  width: 15px;
  height: 15px;
  box-sizing: content-box;
  background: #fff;
  border-radius: 5px;
  cursor: pointer;
  
  svg {
    path {
      fill: ${BLACK} !important;
    }
  }
`;

export const HeaderNameContainer = styled.div`
  border-radius: 100px;
  background: ${GREY_2};
  padding: 8px 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;
